import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Image } from 'antd';
import type { ColumnType } from 'antd/es/table';

import { DragButton } from '@/shared/components';

import styles from './MainReviewsPage.module.scss';
import type { IReviewItemData } from './types';

export const getColumnsData = ({
  setItemToOperate,
  openEditReviewModal,
  openDeleteReviewModal,
}: {
  setItemToOperate: (data: IReviewItemData | null) => void;
  openEditReviewModal: VoidFunction;
  openDeleteReviewModal: VoidFunction;
}) =>
  [
    {
      title: 'Имя и фамилия студента',
      dataIndex: 'name',
      key: 'name',
      width: `34%`,
      ellipsis: true,
    },
    {
      title: 'Текст отзыва',
      dataIndex: 'description',
      key: 'description',
      width: `44%`,
      ellipsis: true,
    },
    {
      title: 'Фото',
      dataIndex: 'photo',
      key: 'photo',
      width: 122,
      render: (_, { photo }) =>
        photo.url && (
          <Image
            className={styles['reviewer-image']}
            width={34}
            height={34}
            src={photo.url}
            preview={{
              cover: <EyeOutlined />,
            }}
          />
        ),
    },
    {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 216,
      render: (_, { id, name, description, photo, position }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <DragButton rowKey={position} />
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, name, description, photo, position });
              openEditReviewModal();
            }}
          >
            <EditOutlined style={{ fontSize: '20px' }} />
          </Button>
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, name, description, photo, position });
              openDeleteReviewModal();
            }}
          >
            <DeleteOutlined style={{ fontSize: '20px' }} />
          </Button>
        </div>
      ),
      fixed: 'right',
    },
  ] as ColumnType<IReviewItemData>[];
